import React from "react";

import TooltipStore from "./common_components/tooltips/TooltipStore";
import LocaleStore from "./common_components/localization/LocaleStore";
import RootStore from "./common_components/tooltips/erb/rootStore";
import MainTooltips from "./common_components/tooltips/MainTooltips";
import { observer, Provider } from "mobx-react";
import { IntlProvider } from "react-intl";

@observer
export default class TooltipsERB extends React.Component {
  constructor(props) {
    super(props);

    const localeStore = new LocaleStore(props.userLocale, []);

    this.rootStore = new RootStore(localeStore);

    const tooltipStore = new TooltipStore(this.rootStore, {
      getSteps: props.getSteps || (() => props.steps),
      sections: props.sections || {}
    });

    this.rootStore.tooltipStore = tooltipStore;
  }

  render() {
    return (
      <Provider rootStore={this.rootStore}>
        <IntlProvider
          locale={this.rootStore.localeStore.locale}
          messages={this.rootStore.localeStore.messages}
        >
          <MainTooltips customJoyrideProps={this.props.joyrideProps} />
        </IntlProvider>
      </Provider>
    );
  }
}
